import './section.scss'
export const SectionLoader = () => (
  <div className="section-loader">
    <div className="loader-line" />
    <div className="loader-line" />
    <div className="loader-line" />
  </div>
);
